import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@guestyci/foundation/enums/enums';
import Carousel from "../Carousel";
import ImageView from "../Image";

var ImageGallery = function ImageGallery(_ref) {
  var images = _ref.images,
      arrows = _ref.arrows,
      arrowTheme = _ref.arrowTheme,
      showArrowsOnHover = _ref.showArrowsOnHover,
      infinite = _ref.infinite,
      height = _ref.height,
      className = _ref.className,
      style = _ref.style,
      crop = _ref.crop;
  var imagesElements = useMemo(function () {
    return images.map(function (image) {
      return /*#__PURE__*/React.createElement(ImageView, {
        responsive: true,
        src: image,
        key: image,
        crop: crop,
        width: "auto",
        height: height
      });
    });
  }, [images]);
  var settings = {
    arrows: arrows,
    infinite: infinite,
    showArrowsOnHover: showArrowsOnHover,
    className: className,
    style: style,
    arrowsFade: true,
    arrowTheme: arrowTheme
  };
  return /*#__PURE__*/React.createElement(Carousel, _extends({}, settings, {
    "data-qa": "image-gallery"
  }), imagesElements);
};

ImageGallery.defaultProps = {
  arrows: true,
  showArrowsOnHover: true,
  infinite: true,
  className: '',
  style: {},
  arrowTheme: Theme.Light,
  height: 300,
  crop: 'fill'
};
ImageGallery.propTypes = {
  /** list of images to show in the gallery */
  images: PropTypes.arrayOf(PropTypes.string).isRequired,

  /** indicates if to display arrows */
  arrows: PropTypes.bool,

  /** indicate if to show the arrows when not hovering the carousel */
  showArrowsOnHover: PropTypes.bool,

  /** Infinitely wrap around contents */
  infinite: PropTypes.bool,

  /** Additional style */
  style: PropTypes.shape(),

  /** Additional class name */
  className: PropTypes.string,

  /** arrow's theme */
  arrowTheme: PropTypes.oneOf([Theme.Light, Theme.Dark]),

  /** height of the gallery */
  height: PropTypes.number,

  /** Crop type */
  crop: PropTypes.string
};
export default ImageGallery;